module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e372a"
    }
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "legalnotice",
    attrs: {
      "id": "d7e372"
    }
  }, [_vm._v("© 1982 by Jack Van Impe Ministries.")]), _vm._v(" "), _c('p', {
    staticClass: "biblioid",
    attrs: {
      "id": "d7e532"
    }
  }, [_vm._v("Published in Nashville, Tennessee, by Thomas Nelson. Thomas Nelson is a registered trademark of Thomas Nelson, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "legalnotice",
    attrs: {
      "id": "d7e632"
    }
  }, [_vm._v("Thomas Nelson, Inc. titles may be purchased in bulk for educational, business, fund-raising, or sales promotional use. For information, please e-mail SpecialMarkets@ThomasNelson.com.")]), _vm._v(" "), _c('p', {
    staticClass: "legalnotice",
    attrs: {
      "id": "d7e802"
    }
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher. ")]), _vm._v(" "), _c('p', {
    staticClass: "printhistoryl",
    attrs: {
      "id": "d7e1042"
    }
  }, [_vm._v("Printed in the United States."), _c('br'), _vm._v("Revised edition, 1992"), _c('br'), _vm._v(" Second printing, 1993"), _c('br'), _vm._v(" Third printing, 1994"), _c('br'), _vm._v(" Fourth printing, 1994 "), _c('br'), _vm._v("Fifth printing, 1994 "), _c('br'), _vm._v("Sixth printing, 1995"), _c('br'), _vm._v(" Seventh printing, 1996"), _c('br'), _vm._v(" Eighth printing, 1996 ")]), _vm._v(" "), _c('p', {
    staticClass: "legalnotice",
    attrs: {
      "id": "d7e1532"
    }
  }, [_vm._v("All Scripture quotations are from the King James Version of the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e372b"
    }
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "legalnotice",
    attrs: {
      "id": "d7e1602"
    }
  }, [_vm._v("For a complete list of recordings, books, and other resource materials by Dr. Jack Van Impe, write for our latest catalog:")]), _vm._v(" "), _c('p', {
    staticClass: "legalnoticec",
    attrs: {
      "id": "d7e1722"
    }
  }, [_vm._v("JACK VAN IMPE MINISTRIES"), _c('br'), _vm._v(" P. O. Box 7004 • Troy, Michigan 48997"), _c('br'), _vm._v(" In Canada: Box 1717, Postal Station A "), _c('br'), _vm._v("Windsor, Ontario N9A 6Y1 ")]), _vm._v(" "), _c('p', {
    staticClass: "isbn",
    attrs: {
      "id": "d7e2102"
    }
  }, [_vm._v("ISBN 978-0-8499-3964-8 ")]), _vm._v(" "), _c('p', {
    staticClass: "printhistory",
    attrs: {
      "id": "d7e2212"
    }
  }, [_c('i', [_vm._v("Printed in the United States of America ")])]), _vm._v(" "), _c('p', {
    staticClass: "other",
    attrs: {
      "id": "d7e221122"
    }
  }, [_vm._v("08 09 10 11 12 QW 20 19 18 17 16 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da1c284","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Impe_ISBN9781418517243_epub_c2_r1.vue
// module id = 60
// module chunks = 0